import { IAuthPayload, IStoreQrDiscount, IUser } from "src/models";
import * as Types from "src/redux/types";

type State = {
  storeQrDiscount?: IStoreQrDiscount;
  isLoaded: boolean;
};

const initialState: State = {
  storeQrDiscount: undefined,
  isLoaded: false,
};

const StoreQrDiscountReducer = (
  state = initialState,
  action: Action<IStoreQrDiscount>
): State => {
  const { type, payload } = action;
  switch (type) {
    case Types.STORE_QR_DISCOUNT_LOAD: {
      const data = payload as IStoreQrDiscount;
      return {
        ...state,
        storeQrDiscount: data,
        isLoaded: true,
      };
    }

    default:
      return state;
  }
};

export default StoreQrDiscountReducer;
